import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76ab187c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "wrapper-global-fix",
  id: "wrapperglb"
}
const _hoisted_2 = { class: "container promocode-container" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promocode-container__header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("Вы классно справились "),
    /*#__PURE__*/_createElementVNode("span", { class: "nobr" }, "с заданием!")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promocode__text-before-button" }, " Закажите продукты от Самоката прямо сейчас, чтобы добавить ещё один яркий момент к этому лету. Или продолжите приключение. ", -1))
const _hoisted_6 = { class: "btn-row btn-row__slim" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageCdn = _resolveComponent("ImageCdn")!
  const _component_LetoButton = _resolveComponent("LetoButton")!
  const _component_PromocodeFooter = _resolveComponent("PromocodeFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ImageCdn, {
          class: "polaroid-new",
          filename: "polaroid-picnic.webp"
        }),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_LetoButton, {
            onClick: _ctx.next,
            class: "btn-promo",
            text: "Продолжить"
          }, null, 8, ["onClick"])
        ]),
        _createVNode(_component_PromocodeFooter)
      ])
    ])
  ]))
}